import ReactDOM from "react-dom/client";
import App from "./App";
import "./style/general.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
